import { dropByCacheKey, getCachingKeys } from 'react-router-cache-route';

import React from "react";

// 路由导航
export default class NavUtils {

  static history;

  static setHistory(history) {
    NavUtils.history = history;
  }

  static linkTo(url, state, clearCatch = false) {
    if (NavUtils.history.location.pathname !== url) {
      if (clearCatch) {
        dropByCacheKey(url);
        Promise.resolve().then(() => {
          NavUtils.history.push(url, state);
        });
      } else {
        NavUtils.history.push(url, state); 
      }
    }
  }

  static back() {
    NavUtils.history.goBack();
  }

  static test() {
    console.log(NavUtils.history);
  }

  static replace(path, state) {
    NavUtils.history.replace(path, state);
  }
}
